import {
  GearOutlineIcon,
  IconButton,
} from "@tandemdiabetes/sugarmate-react-components"
import { useCallback } from "react"
import styles from "./InsulinAndMedication.module.scss"
import { useAccountMedicationModalContext } from "src/components"
import type { AccountMedication } from "src/types"

interface Props {
  accountMedication: AccountMedication;
}

export function AccountMedicationComponent(props: Props) {
  const { accountMedication } = props
  const { openAccountMedicationModal } = useAccountMedicationModalContext()

  const onClick = useCallback(
    () => {
      openAccountMedicationModal(accountMedication)
    },
    [
      accountMedication,
      openAccountMedicationModal,
    ],
  )

  // TODO componentize like CGMMenuItem ?
  return (
    <li
      className={styles.listItem}
      id="medication-item"
    >
      <div className={styles.listItemText}>
        <div className={styles.listItemTopRow}>
          <span className={styles.listItemName}>
            {accountMedication.med.name}
          </span>
          <span className={styles.listItemUnit}>
            {accountMedication.units}
          </span>
        </div>
        <div className={styles.listItemDescription}>
          {accountMedication.med.description}
        </div>
      </div>
      <IconButton
        className={styles.listItemSettingsButton}
        stylePreset="withoutBackground"
        onClick={onClick}
        id="medication-setting-icon"
      >
        <GearOutlineIcon />
      </IconButton>
    </li>
  )
}
